import { footerColumns, siteInfo } from "@/mocks/site";

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="w-full bg-primary-950">
      <div className="mx-auto w-full max-w-[1180px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-[1.6fr_1fr_1fr_1fr]">
          <div>
            <div className="flex items-center gap-3">
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-600 font-heading text-lg font-bold text-background-50">
                曝
              </span>
              <span>
                <span className="block font-heading text-lg font-bold text-background-50">{siteInfo.name}</span>
                <span className="block text-[11px] text-background-300">{siteInfo.tagline}</span>
              </span>
            </div>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-background-300">{siteInfo.description}</p>
            <p className="mt-5 flex items-center gap-2 text-sm text-background-200">
              <i className="ri-mail-line text-primary-300" />
              {siteInfo.email}
            </p>
          </div>

          {footerColumns.map((column) => (
            <nav key={column.id} aria-label={column.title}>
              <h3 className="font-heading text-sm font-bold tracking-wide text-background-50">{column.title}</h3>
              <ul className="mt-4 space-y-3">
                {column.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="cursor-pointer text-sm text-background-300 transition-colors hover:text-primary-300"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-primary-800 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs leading-relaxed text-background-400">
            站内内容均为读者投稿改编的虚构情节合集，人物与细节已模糊处理，不对应任何真实个人。
          </p>
          <p className="text-xs text-background-400">
            © {year} {siteInfo.name} · {siteInfo.weeklyUpdate}
          </p>
        </div>
      </div>
    </footer>
  );
}